import styled, { css } from 'styled-components'
import { device } from '../../../styles/Breakpoints'

export const VSMGridContainer = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1200px;
	margin: 0 auto;
	background-color: #fff;
	scroll-margin-top: 120px;

	@media ${device.sm} {
		padding: 0 20px 20px;
	}

	h3 {
		font-size: 15px;
		margin: 0 10px;
		font-weight: 600;
	}
`

export const ThumbsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	h3 {
		text-transform: uppercase;
		letter-spacing: 0.2em;
		margin-top: 15px;
	}
`

export const VSMGridNav = styled.div`
	width: 100%;
	margin-bottom: 40px;

	li.swiper-slide {
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		&.swiper-slide-prev {
			${ThumbsContainer} {
				position: absolute;
				top: 0;
				right: -10%;
			}
		}

		&.swiper-slide-next {
			${ThumbsContainer} {
				&.mobile {
					position: absolute;
					top: 0;
					left: 5%;
				}
			}
		}

		&.swiper-slide-next + .swiper-slide {
			${ThumbsContainer} {
				&.tablet {
					position: absolute;
					top: 0;
					left: 10%;
				}
			}
		}
	}

	@media only screen and (min-width: 768px) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
	}
`

export const VSMGridNavIcon = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`

export const TabIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	height: 100%;

	img {
		&.superheroIcon {
			width: 48px;
			box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
			border-radius: 50%;
		}
		&.secondaryIcon {
			width: 30px;
			position: absolute;
			bottom: 10px;
			right: 5px;
			z-index: 1;
			box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
			border-radius: 50%;
		}
	}
`

export const TabCopyContainer = styled.div`
	display: block;
	position: relative;
	width: 100%;
`

export const TabCopy = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: absolute;
	top: -30px;
	transition: all 0.4s ease;

	@media ${device.sm} {
		top: -15px;
	}

	h3 {
		line-height: 1.2;
		margin-bottom: 3px;
	}
`

export const Tab = styled.div`
	display: grid;
	grid-template-columns: 70px 1fr;
	align-items: center;
	border-radius: 5px;
	grid-template-rows: 85px;
	position: relative;
	transition: transform 0.4s ease;

	p {
		display: flex;
		font-size: 11px;
		margin: 0 10px;
	}

	@media ${device.sm} {
		p {
			opacity: 0;
			transition: opacity 0.7s ease;
		}

		&.hovered {
			transform: scale(1.05);

			// ${TabCopy} {
			// 	top: -35px;

			// 	p {
			// 		opacity: 1;
			// 	}
			// }

			// &.colSpan-2,
			// &.colSpan-3,
			// &.colSpan-4 {
			// 	/* grid-template-columns: 70px 1fr; */
			// 	-webkit-mask-image: unset;
			// 	mask-image: unset;
			// 	transform: scale(1.02);
			// }

			// &.colSpan-4 {
			// 	transform: scale(1.01);
			// }
		}
	}

	&.ideate {
		/* grid-column: 1; */
		background-color: #fff9e9;
		border-top: 6px solid #ffc322;
		&.colSpan-2 {
			/* grid-column: 1 / span 2; */
			background-image: linear-gradient(to right, #fff9e9, #f0e6f5);
			border-image: linear-gradient(90deg, #ffc322, #a049ca) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
		&.colSpan-3 {
			grid-column: 1 / span 3;
			background-image: linear-gradient(to right, #fff9e9, #f0e6f5, #fff2ed);
			border-image: linear-gradient(90deg, #ffc322, #a049ca, #eb4a10) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
		&.colSpan-4 {
			grid-column: 1 / span 4;
			background-image: linear-gradient(to right, #fff9e9, #f0e6f5, #fff2ed, #f1fefe);
			border-image: linear-gradient(90deg, #ffc322, #a049ca, #eb4a10, #00abb3) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
	}
	&.create {
		grid-column: 2;
		background-color: #f0e6f5;
		border-top: 6px solid #a049ca;
		&.colSpan-2 {
			grid-column: 2 / span 2;
			background-image: linear-gradient(to right, #f0e6f5, #fff2ed);
			border-image: linear-gradient(90deg, #a049ca, #eb4a10) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
		&.colSpan-3 {
			grid-column: 1 / span 3;
			background-image: linear-gradient(to right, #f0e6f5, #fff2ed, #f1fefe);
			border-image: linear-gradient(90deg, #a049ca, #eb4a10, #00abb3) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
	}
	&.release {
		grid-column: 3;
		background-color: #fff2ed;
		border-top: 6px solid #eb4a10;
		&.colSpan-2 {
			grid-column: 3 / span 2;
			background-image: linear-gradient(to right, #fff2ed, #f1fefe);
			border-image: linear-gradient(90deg, #eb4a10, #00abb3) 1;
			border-left: 0px;
			border-right: 0px;
			border-bottom: 0px;
			-webkit-mask-image: -webkit-radial-gradient(white, black);
			mask-image: -webkit-radial-gradient(white, black);
		}
	}
	&.operate {
		grid-column: 4;
		background-color: #f1fefe;
		border-top: 6px solid #00abb3;
	}

	h3 {
		font-size: 13px;

		@media only screen and (min-width: 992px) {
			font-size: 15px;
		}
	}
`

export const HoverTab = styled.div`
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	position: absolute;
	width: 310px;
	height: 130px;
	bottom: -25px;
	left: -10px;
	border-radius: 5px;
	z-index: 10;
	box-shadow: 3px 5px 10px #888888;

	&.ideate-hover {
		background-color: #fff9e9;

		h3 {
			background: #ffc322;
		}
	}
	&.create-hover {
		background-color: #f0e6f5;

		h3 {
			background: #a049ca;
		}
	}
	&.release-hover {
		background-color: #fff2ed;

		h3 {
			background: #eb4a10;
		}
	}
	&.operate-hover {
		background-color: #f1fefe;

		h3 {
			background: #00abb3;
		}
	}

	h3 {
		display: flex;
		flex: 0 100%;
		justify-content: center;
		align-items: center;
		height: 30px;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		margin: 0;
	}

	${TabIcon} {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1 0 35%;
		width: 100%;
		height: 100px;

		img.superheroIcon {
			width: 60px;
			position: absolute;
			left: 25px;
			top: 5px;
		}

		img.secondaryIcon {
			width: 30px;
			bottom: 25px;
			right: 15px;
		}
	}

	p {
		margin-top: 0;
		flex: 1 0 65%;
		font-size: 13px;
	}
`

export const TabContainer = styled.div`
	box-shadow: 0px 0px 6px 0 rgb(0 0 0 / 11%);
	border-radius: 5px;

	&.column-ideate {
		grid-column: 1;
	}

	&.column-create {
		grid-column: 2;
	}

	&.column-release {
		grid-column: 3;
	}

	&.column-operate {
		grid-column: 4;
	}

	&.columns-2 {
		grid-column: span 2;
	}

	&.columns-3 {
		grid-column: span 3;
	}

	&.columns-4 {
		grid-column: span 4;
	}

	@media ${device.sm} {
		&.hoverShadow {
			box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
		}

		// ${Tab} {
		// 	grid-template-columns: 50px 1fr;
		// }

		// ${TabIcon} {
		// 	img.superheroIcon {
		// 		width: 40px;
		// 	}

		// 	img.secondaryIcon {
		// 		width: 25px;
		// 		right: -5px;
		// 	}
		// }

		// ${TabCopy} {
		// 	h3 {
		// 		font-size: 11px;
		// 	}

		// 	p {
		// 		font-size: 10px;
		// 	}
		// }
	}

	@media only screen and (min-width: 1100px) {
		${Tab} {
			grid-template-columns: 70px 1fr;
		}

		${TabIcon} {
			img.superheroIcon {
				width: 48px;
			}

			img.secondaryIcon {
				width: 30px;
				right: 5px;
			}
		}

		${TabCopy} {
			h3 {
				font-size: 14px;
				line-height: unset;
			}

			p {
				font-size: 11px;
			}
		}
	}
`

export const VSMGrid = styled.div`
	padding: 0 10px;

	div.swiper-wrapper {
		display: flex;

		${TabContainer} {
			grid-row-start: ${(props) => props.gridRow};
		}
	}

	@media only screen and (min-width: 768px) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
		padding: 0;
	}
`

export const VSMGridColumn = styled.div`
	display: grid;
	grid-row-gap: 15px;

	${({ gridRows }) =>
		gridRows &&
		css`
			grid-template-rows: repeat(${gridRows}, 85px);
		`}

	${TabContainer} {
		grid-row-start: ${(props) => props.gridRow};
		&.column-ideate,
		&.column-create,
		&.column-release,
		&.column-operate {
			grid-column: 1;
			&.columns-2 {
				width: calc(200% + 10px);
			}
			&.columns-3 {
				width: calc(300% + 20px);
			}
			&.columns-4 {
				width: calc(400% + 30px);
			}
		}
	}
`
